import hasAllowedCharacters from "./../validations/has.allowed.characters";

export default (values, value) => hasAllowedCharacters(value);
